var _circle, _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 46.4521,
    cy: 46.4521,
    r: 46.4521,
    fill: "#356733"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6344,
    cy: 36.802,
    rx: 9.27938,
    ry: 9.51731,
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9153 59.5561C30.9128 58.887 31.0587 58.2261 31.342 57.6234C32.2308 55.8002 34.7373 54.8339 36.8171 54.3963C38.3171 54.068 39.8378 53.8487 41.368 53.7399C44.2008 53.4847 47.0501 53.4847 49.8829 53.7399C51.4129 53.8499 52.9335 54.0692 54.4337 54.3963C56.5136 54.8339 59.0201 55.709 59.9089 57.6234C60.4785 58.852 60.4785 60.2783 59.9089 61.5069C59.0201 63.4213 56.5136 64.2965 54.4337 64.7158C52.9355 65.0577 51.4143 65.2832 49.8829 65.3904C47.5772 65.5909 45.2607 65.6275 42.9501 65.4998C42.4168 65.4998 41.9012 65.4998 41.368 65.3904C39.8424 65.2846 38.3269 65.059 36.8349 64.7158C34.7373 64.2965 32.2486 63.4213 31.342 61.5069C31.0602 60.8972 30.9144 60.2308 30.9153 59.5561Z",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/userCircle.f0c4679eb9a89242c586a0fb8b6b2945.svg";
export { ForwardRef as ReactComponent };